<template>
  <div>
      <div class="mylinks">

      </div>
      <div class="footer">
          <div class="footer-col">
              <div class="footer-col-logo">
                <img src="../../assets/logo-nav.png">
              </div>
              <div class="footer-col-content">
                <p>本网站文字、图像、音视频资料版权及最终解释权归东北抗日义勇军纪念馆所有，如有疑问，请联系我们更正，任何单位及个人未经允许，不得引用和翻录。</p>
                <p>
                  <span>地址：辽宁省本溪市桓仁满族自治县桓仁镇东关村1组</span>
                  <span>联系电话：024-48889088</span>
                </p>
                <p>

<!--                  <span>辽公网安备123012458号</span>-->
                  <span><a  href="https://beian.miit.gov.cn" target="_blank">备案号：辽ICP备2023011290号</a></span>
                </p>
                <p>
                  <span>版权所有：东北抗日义勇军纪念馆</span>
                  <span>Copyright © 2023 Hsjy All Rights Reserved.</span>
                </p>

              </div>
              <div class="foot-col-qrcode">
                <img src="../../assets/qrcode.jpg" >
                <p>扫描二维码关注公众号</p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "FooterYjj"
}
</script>

<style scoped>
  .footer{
    background: #9E1A28;
    height:220px;
    color:#FFECB2;
    text-align: left;
  }
  .footer a{
    color:#FFECB2;
    text-decoration: none;
  }
  .footer-col{
    width: 80%;
    margin: 0 auto;
    display: flex;
  }
  .footer-col-logo{
    flex:2;
    height:220px;
    position: relative;
  }
  .footer-col-logo img{
    width:100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .footer-col-content{
    flex: 5;
    padding: 30px 20px 0 0;
  }
  .footer-col-content p{
    margin-top: 10px;
    line-height: 23px;
  }
  .footer-col-content p span{
    display: inline-block;
    margin-right: 30px;
  }
  .foot-col-qrcode{
    flex:1;
    text-align: left;
    padding-top: 20px;
    font-size: 14px;
  }
  .foot-col-qrcode img{
    width:80%;

  }
  .foot-col-qrcode p{
    padding-top: 5px;
  }
</style>
